import "../../../assets/scss/components/sections/home/features-3.scss";
import { Col, Container, Image, Row } from "react-bootstrap";

import icon1 from "../../../assets/images/home/feature3-icon-1.svg";
import icon2 from "../../../assets/images/home/feature3-icon-2.svg";
import icon3 from "../../../assets/images/home/feature3-icon-3.svg";
import feature3img from "../../../assets/images/home/feature-1.svg";
import Btn from "../../templates/button";

import shape1 from "../../../assets/images/home/shape-2.svg";
const Features3 = () => {
  return (
    <div className="features-3-section">
      <Container>
        <div className="features-3">
          <div className="content">
            <Row>
              <Col lg={6}>
                <div className="left-content">
                  <div className="heading">
                    <h3 className="heading-3">
                      100% Guarantee to pass any ATS
                    </h3>
                    <p className="paragraph-small-regular">
                      Our AI algorithm ensures your resume is ATS-compliant
                    </p>
                  </div>
                  <div className="features-list">
                    <div className="list-item">
                      <div className="icon icon-1">
                        <Image src={icon1} />
                      </div>
                      <div className="text">
                        <h4 className="heading-6">Keyword Optimization</h4>
                        <p className="paragraph-small-regular">
                          Match your resume with job-specific keywords
                        </p>
                      </div>
                    </div>
                    <div className="list-item">
                      <div className="icon icon-2">
                        <Image src={icon2} />
                      </div>
                      <div className="text">
                        <h4 className="heading-6">Increased Visibility </h4>
                        <p className="paragraph-small-regular">
                          Boost your chances of being seen
                        </p>
                      </div>
                    </div>
                    <div className="list-item">
                      <div className="icon icon-3">
                        <Image src={icon3} />
                      </div>
                      <div className="text">
                        <h4 className="heading-6">Perfect Formatting </h4>
                        <p className="paragraph-small-regular">
                          Ensure ATS-compatible formatting
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="create-btn text-center text-lg-start">
                    <Btn
                      text="Create ATS-Optimized Resume"
                      class="btn-secondary"
                      handle={() => {
                        window.location.href =
                          process.env.REACT_APP_APP_REGISTER_URL;
                      }}
                    />
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className="right-content">
                  <div className="image">
                    <Image src={feature3img} />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Features3;
